// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"Paragraph_Paragraph__q_Qc4"};